import { DOCUMENT } from '@angular/common';
import { Injectable, Signal, inject } from '@angular/core';

import { ScrollContainerService } from '@frontend/sports/common/core/utils/scroll-container';
import { ScrollProxyService } from '@frontend/sports/common/core/utils/scroll-service-proxy';
import { Store } from '@ngrx/store';

import { selectIsQuickBetSuccess } from '../../betslip/modules/quick-bet/quick-bet.selectors';
import { IQuickBetState } from '../../betslip/modules/quick-bet/quick-bet.state';

@Injectable({
    providedIn: 'root',
})
export class HideHeaderService {
    scrollLastPosition = 0;
    private quickBetUiState: Signal<boolean>;

    private readonly _doc = inject(DOCUMENT);
    private readonly scrollProxy = inject(ScrollProxyService);

    scrollProxyConsumer = this.scrollProxy.onScroll$.subscribe(() => this.onScroll());
    scrollResetConsumer = this.scrollProxy.onReset$.subscribe(() => this.removeHideHeader());

    constructor(
        private scrollContainer: ScrollContainerService,
        private store: Store<IQuickBetState>,
    ) {
        this.quickBetUiState = this.store.selectSignal(selectIsQuickBetSuccess);
    }

    onScroll() {
        if (this.quickBetUiState()) {
            return;
        }

        if (this.scrollContainer.scrollTop > 5 && this.scrollContainer.scrollTop >= this.scrollLastPosition) {
            const headerElement = this._doc.querySelector('.slot-header_bottom_items') as HTMLElement;
            const scrollHeight = headerElement.offsetTop;
            const scrollTop = (Math.abs(scrollHeight) * -1).toString();
            this._doc.querySelector('.slot-header')?.setAttribute('style', `top:${scrollTop}px`);
        } else {
            this._doc.querySelector('.slot-header')?.removeAttribute('style');
        }
        this.scrollLastPosition = this.scrollContainer.scrollTop;
    }

    removeHideHeader() {
        this._doc.querySelector('.slot-header')?.removeAttribute('style');
    }
}
